import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles, Box, Typography } from "@material-ui/core";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";

import LoaderView from "../../../components/LoaderView";
import { isEmptyObject } from "utils";
import zIndex from "@material-ui/core/styles/zIndex";
import ApexCharts from "react-apexcharts";
import ReactDOMServer from 'react-dom/server';

const useStyles = makeStyles({});

const ActivityHoursPlanned = (props) => {
  const {
    plannedActivityHoursData,
    plannedActivityHoursDataLoading,
    districtBuildingMapLoading,
    selectedBuildingLength,
  } = props;

  
 
console.log("plannedActivityHoursData",plannedActivityHoursData)

  const renderCustomizedLabelAssetCount = (props) => {
    const {
      x, y, width, height, value,
    } = props;
 
  
  const fireOffset =  isNaN(value) ;
  const offset = fireOffset ? -25 : 5;
  
    return (
        <text  x={fireOffset ? x-offset : x+(width/2)} y={y+(height/2)+5} fill = {isNaN(value) ? "black" : "white" } textAnchor="middle">
         {isNaN(value) ? 'NaN' : value}
       </text>
    );
  };
  const renderCustomizedLabel = (props) => {
    const {
      x, y, width, height, value,
    } = props;
 
  
  const fireOffset = value <= 0;
  const offset = fireOffset ? -15 : 5;
    return (
        <text  fill={"white"} x={x + width - offset} y={y + (height/2) + 5}  textAnchor="end">
         {value ? value : ''}
       </text>
    );
  };
  
  const classes = useStyles(),
    { t } = useTranslation();

  const CustomTooltip = ({series, seriesIndex, dataPointIndex, w}) => {
    const payload = [{payload: w.config.series[seriesIndex]?.['data']?.[dataPointIndex]}]
    if (payload && payload.length) {
      let perEff =  Number(payload[0].payload.targetAph) > 0 && payload[0].payload.aph>0 ? 
      Number(payload[0].payload.aph)/ Number(payload[0].payload.targetAph) : 0
      let targetCountCheck = Number(payload[0].payload.targetCount);
      return (
        `${ReactDOMServer.renderToString(
        <Card variant="outlined">
          <CardContent  style={{top : '-20 px' }}>
          { selectedBuildingLength === 1  && 
          <Typography
              variant="body1"
              component="div" 
            >{`Planned Count : ${(Number(payload[0].payload.targetCount))}`}</Typography>
          }
            <Typography
              variant="body1"
              component="div"
            >{`Duration : ${Number(payload[0].payload.activityHours).toFixed(2)} hrs`}</Typography>
            <Typography
              variant="body1"
              component="div"
            >{`APH : ${payload[0].payload.aph}`}</Typography>
             {Number(perEff)>0 && <Typography
              variant="body1"
              component="div"
            >{`% Achievement : ${Number(perEff*100).toFixed(2)}%`}</Typography>}
          </CardContent>
        </Card>
        )}`
      );
    }

    return null;
  };

  const apexOptions = {
    chart: {
      height: 350,
      type: 'bar'
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '35',
        columnWidth: '40px'
      }
    },
    colors: ["#00a88e"],
    dataLabels: {
      offsetX: 10, // Position data labels at the end of bars
      textAnchor: "start",
      // position: 'end', // Place data labels at the end of bars
      enabled: true,
      formatter: function(val, opt) {
        const goals =
          opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
            .goals
    
        if (goals && goals.length) {
          return `${val} / ${goals[0].value}`
        }
        return val == 0 ? '0' : val
      },
      style:{
        colors: ['#000'],
        fontSize: '14px',
        fontWeight: 700
      },
      // dropShadow: {
      //   enabled: true,
      //   opacity: 1,
      //   blur: 1,
      //   color: "#000",
      //   offsetX: 1,
      //   offsetY: 1,
      // },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'center',
      floating: true,
      show: true,
      showForSingleSeries: true,
      customLegendItems: ['Actual', 'Planned'],
      markers: {
        fillColors: ["#00a88e", '#775DD0']
      }
    },
    grid: {
      show: true
    },
    xaxis: {
      categories: plannedActivityHoursData.length>0 ? 
                  plannedActivityHoursData.map(item => t(`other.${item.x}`)) :[],
      labels: {
        // style: {
        //   fontSize : '14px'
        // },
        show: true
      },
      axisBorder: {
        show: true,  // Hide the axis line (border)
      },
      axisTicks: {
        show: true, // Hide x-axis ticks
      },
      title: {
        text: 'Asset Count',
       // offsetY: -20,
        horizontalAlign: 'center',
      },
      min: 0
    },
    yaxis: {
      labels: {
        style: {
          fontSize : '1rem'
        },
      },
      axisBorder: {
        show: true,  // Hide the axis line (border)
      },
      min: 0
    },
    tooltip: { 
      custom: CustomTooltip,
      followCursor: true,  // Makes the tooltip follow the cursor
      shared: false,       // Disable shared tooltip (individual tooltips for each series)
      fixed: true,
    } 
  }

  return (
    <>
      <LoaderView
        loading={plannedActivityHoursDataLoading || districtBuildingMapLoading}
      >
        
         {!isEmptyObject(plannedActivityHoursData) ? (
         <div style={{  overflowY: (plannedActivityHoursData.length * 45)+120 >= 500 ? 'scroll' : 'hidden'}}>
           <ResponsiveContainer
            width="99%"
            height={(plannedActivityHoursData.length * 45)+120}
          >
            <ApexCharts 
              options={apexOptions}
              series={[
                {
                  name: 'Actual',
                  data: plannedActivityHoursData
                }
              ]}
              type="bar"
              height={'100%'}
            />
          </ResponsiveContainer>
         </div>
        ) : (
          <Box className={classes.full}>
            <Alert severity="info">{t("other.errNoReportData3")}</Alert>
          </Box>
        )}
      </LoaderView>
    </>
  );
};

export default ActivityHoursPlanned;
